<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="search-wrapper">
         <el-form inline :model="queryForm">
            <el-form-item label="校区名称">
               <el-select v-model="queryForm.schoolId" placeholder="请选择校区" filterable clearable>
                  <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.rootUnid">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="设备UID">
               <el-input placeholder="请输入设备UID" clearable :maxlength="100" v-model="queryForm.uid"></el-input>
            </el-form-item>
            <el-form-item label="在线状态">
               <el-select v-model="queryForm.status">
                  <el-option label="全部" value="0"></el-option>
                  <el-option label="在线" value="1"></el-option>
                  <el-option label="离线" value="2"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item>
               <el-button type="primary" @click="clickQuery">搜索</el-button>
               <el-button @click="clickReset">重置</el-button>
            </el-form-item>
         </el-form>
      </div>

      <div class="content-wrapper">
         <el-table :data="tableData" border style="width: 100%;">
            <el-table-column align="center" label="序号" width="80" type="index"></el-table-column>
            <el-table-column align="center" label="设备名称" prop="name"></el-table-column>
            <el-table-column align="center" label="设备UID" prop="uid"> </el-table-column>
            <el-table-column align="center" label="激活日期" width="200" prop="activeTime"></el-table-column>
            <el-table-column align="center" label="最后心跳" width="200" prop="heartbeatTime"></el-table-column>
            <el-table-column align="center" label="在线状态" width="120">
               <template scope="{ row }">
                  <span>{{ row.status === 1 ? "是" : "否" }}</span>
               </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="380">
               <template scope="{ row }">
                  <el-button type="text" size="small" @click="clickDetail(row)">查看详情</el-button>
                  <el-button type="text" size="small" @click="clickLogDownload(row)">日志下载</el-button>
                  <el-button type="text" size="small" @click="clickEditName(row)">编辑名称</el-button>
                  <el-button type="text" size="small" @click="clickDelete(row)">设备删除</el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <div class="pagination-wrapper">
         <el-pagination v-show="total > 0" layout="prev, pager, next" :current-page="queryForm.pageNum"
            :page-size='queryForm.pageSize' :total="total" @current-change="changeCurrentPage">
         </el-pagination>
      </div>

      <el-dialog title="日志下载" v-model="logDialog.visible" :close-on-click-modal="false" :modal-append-to-body="false">
         <el-form label-width="80px">
            <el-form-item label="选择日志">
               <el-select v-model="logDialog.selectPath" placeholder="请选择日志" filterable style="width: 100%;">
                  <el-option v-for="(item, index) in logDialog.data" :key="index" :label="item.label"
                     :value="item.value">
                  </el-option>
               </el-select>
            </el-form-item>
         </el-form>
         <template #footer>
            <el-button @click="logDialog.visible = false">取消</el-button>
            <el-button type="primary" @click="clickDonload">下载</el-button>
         </template>
      </el-dialog>

      <el-dialog custom-class="dialog-wrapper" title="编辑名称" v-model="editDialog.visible" :close-on-click-modal="false"
         :modal-append-to-body="false">
         <el-form ref="editFormRef" :model="editDialog.form" :rules="editDialog.rules" label-width="80px">
            <el-form-item label="设备名称" prop="name">
               <el-input v-model="editDialog.form.name" type="text" :maxlength="9" show-word-limit clearable></el-input>
            </el-form-item>
         </el-form>
         <template #footer>
            <div class="flex-row-center">
               <el-button @click="editDialog.visible = false">取消</el-button>
               <el-button type="primary" @click="clickEditDone">确定</el-button>
            </div>
         </template>
      </el-dialog>
   </div>
</template>

<script>
export default {
   data() {
      return {
         loading: false,
         queryForm: {
            schoolId: '',
            uid: '',
            status: '',
            type: 1,
            pageNum: 1,
            pageSize: 10,
         },
         schoolList: [],
         tableData: [],
         total: 0,
         logDialog: {
            visible: false,
            data: [],
            selectPath: '',
         },
         editDialog: {
            visible: false,
            form: { name: '', uid: '' },
            rules: { name: [{ required: true, message: '名称不能为空', trigger: 'blur' }] },
         }
      }
   },

   mounted() {
      this.queryAllSchool();
   },

   methods: {
      // 获取所有学校
      queryAllSchool() {
         this.loading = true;
         this.$http({
            method: "get",
            url: this.$util.domain + "/adminapi/v1/basicTools/schoolList",
         }).then((response) => {
            if (response.data.error == 10000) {
               this.schoolList = response.data.data;
               if (this.schoolList.length > 0) {
                  let item = this.schoolList[this.schoolList.length - 1];
                  this.queryForm.schoolId = item.rootUnid;
                  this.queryList();
               }
            } else {
               this.$util.errorMsg(response.data.message);
            }
         }).finally(() => {
            this.loading = false;
         });
      },

      // 查询设备列表请求
      queryList() {
         this.loading = true;
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/hw/onePc/v310/listPage',
            headers: { channelCode: this.$util.envType == 'pre' ? 'iydsjpre' : 'iydsj' },
            params: this.queryForm,
         }).then((result) => {
            if (!result.data.data || JSON.stringify(result.data.data) === '{}') {
               this.total = 0;
               this.tableData = [];
               return;
            }
            this.total = result.data.data.total || 0;
            this.tableData = result.data.data.content || [];
         }).catch(() => {
            this.total = 0;
            this.tableData = [];
         }).finally(() => {
            this.loading = false;
         });
      },

      // 查询日志文件列表
      queryLogs(uid) {
         this.loading = true;
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/sys/file/log/v210/list',
            params: { uid },
         }).then((res) => {
            if (!res.body.data || JSON.stringify(res.body.data) === '[]') {
               this.logDialog.data = []
               this.logDialog.selectPath = ''
               this.$util.errorMsg('暂未查询到日志文件')
               return
            }
            this.logDialog.data = res.body.data.map((item) => {
               return {
                  label: item.fileName,
                  value: item.filePath,
               }
            }).sort((item1, item2) => {
               return item1.label > item2.label ? -1 : 1
            })
            this.logDialog.selectPath = this.logDialog.data[0].value
            this.logDialog.visible = true
         }).catch(() => {
            this.logDialog.data = []
            this.logDialog.selectPath = ''
            this.$util.errorMsg('查询日志文件失败')
         }).finally(() => {
            this.loading = false;
         })
      },

      // 发送更新设备名称
      sendUpdateName() {
         this.loading = true;
         this.$http({
            method: 'post',
            url: this.$util.aioIP + '/api/m/hw/onePc/v202/update',
            body: this.editDialog.form,
         }).then((res) => {
            if (res.body.data === true) {
               this.editDialog.visible = false;
               this.$util.successMsg('编辑成功');
               this.queryList();
            } else {
               this.$util.errorMsg(res.body.msg);
            }
         }).catch(() => {
            this.editDialog.visible = false
            this.$util.errorMsg('编辑失败')
         }).finally(() => {
            this.loading = false;
         })
      },

      // 删除设备请求
      queryDelete(uid) {
         this.loading = true;
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/hw/onePc/v210/delete',
            params: { uid },
         }).then((res) => {
            if (res.body.data && res.body.data == true) {
               this.$util.successMsg('删除成功');
               this.queryList();
            } else {
               this.$util.errorMsg(res.body.msg);
            }
         }).catch(() => {
            this.$util.errorMsg('删除失败，请稍后再试。');
         }).finally(() => {
            this.loading = false;
         })
      },

      // 点击查询
      clickQuery() {
         this.queryList();
      },

      // 点击重置
      clickReset() {
         this.queryForm = {
            schoolId: '',
            uid: '',
            status: '',
            type: 1,
            pageNum: 1,
            pageSize: 20,
         };
         if (this.schoolList.length > 0) {
            let item = this.schoolList[this.schoolList.length - 1];
            this.queryForm.schoolId = item.rootUnid;
         }
         this.queryList();
      },

      // 点击查看详情
      clickDetail(row) {
         this.$router.push({
            path: '/xiaoyuan/equipment/list/detail',
            query: {
               schoolId: this.queryForm.schoolId,
               uid: row.uid,
               type: 'sit'
            }
         })
      },

      // 点击下载日志
      clickLogDownload(row) {
         this.queryLogs(row.uid)
      },

      // 点击编辑名称
      clickEditName(row) {
         this.editDialog.form.uid = row.uid;
         this.editDialog.form.name = row.name;
         this.editDialog.visible = true;
      },

      // 点击设备删除
      clickDelete(row) {
         this.$confirm('是否删除此设备?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.queryDelete(row.uid);
         }).catch(() => { });
      },

      // 点击日志下载
      clickDonload() {
         location.href = this.$util.aioIP + '/file' + this.logDialog.selectPath;
         this.logDialog.visible = false;
      },

      // 点击编辑名称确定
      clickEditDone() {
         this.$refs.editFormRef.validate((valid) => {
            if (valid == false || !this.editDialog.form.uid) { return; }
            this.sendUpdateName();
         })
      },

      // 切换页码
      changeCurrentPage(value) {
         this.queryForm.pageNum = value;
         this.queryList();
      }
   }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// EquipmentSit.vue?0819f7b6